// extracted by mini-css-extract-plugin
export default {"error_message":"ValidateEmailSetup_error_message__2C-ry","loading_container":"ValidateEmailSetup_loading_container__oDRe4"};